import { createSlice } from "@reduxjs/toolkit";
import { getBrandList, getClientList, getCompanyUsers, getMarketList, ownPersonalInfo } from "./thunk";
import { getOtherUserPermission } from "../permission/thunk";

export const initialState = {
	// Personal Details
	personalInfo: null,
	personalInfoErr: false,
	personalInfoErrMsg: null,
	// Change Password
	changePasswordMsg: null,
	changePasswordError: false,
	changePasswordSuccess: false,
	// Company Details
	company: null,
	clients: null,
	selectedClientId: null,
	brands: null,
	selectedBrandId: null,
	markets: null,
	selectedMarketId: null,
	companyErr: false,
	companyErrMsg: null,
	billing: null,
	// User List
	userList: null,
	userListError: false,
	userListErrorMsg: null,
	selectedUserId: null,
	userPermission: null,
	inviteUserError: false,
	inviteUserErrorMsg: null,
	companyErr: false,
	companyErrMsg: null,
	clientErr: false,
	clientErrMsg: null,
	brandErr: false,
	brandErrMsg: null,
	marketErr: false,
	marketErrMsg: null
};

const settingsSlice = createSlice({
	name: "Settings",
	initialState,
	reducers: {
		/* eslint-disable require-jsdoc */
		// Personal Details
		getOwnPersonalInfoSuccess(state, action) {
			state.personalInfo = action.payload;
		},
		getOwnPersonalInfoErr(state, action) {
			state.personalInfoErr = true;
			state.personalInfoErrMsg = action.payload;
		},
		// Change Password
		passwordChangeSuccess(state, action) {
			state.changePasswordSuccess = true;
			state.changePasswordError = false;
			state.changePasswordMsg = action.payload;
		},
		passwordChangeError(state, action) {
			state.changePasswordSuccess = false;
			state.changePasswordError = true;
			state.changePasswordMsg = action.payload;
		},
		resetPwdChangeErr(state) {
			state.changePasswordSuccess = false;
			state.changePasswordError = false;
			state.changePasswordMsg = null;
		},
		resetPwdChangeSuccess(state) {
			state.changePasswordSuccess = false;
			state.changePasswordError = false;
			state.changePasswordMsg = null;
		},
		// Company Details
		getCompanySuccess(state, action) {
			state.company = action.payload;
		},
		getCompanyError(state, action) {
			state.companyErr = true;
			state.companyErrMsg = action.payload;
		},
		getClientSuccess(state, action) {
			state.clients = action.payload;
		},
		getClientError(state, action) {
			state.companyErr = true;
			state.companyErrMsg = action.payload;
		},
		setClientId(state, action) {
			state.selectedClientId = action.payload;
		},
		getBrandSuccess(state, action) {
			state.brands = action.payload;
		},
		setBrandId(state, action) {
			state.selectedBrandId = action.payload;
		},
		getMarketSuccess(state, action) {
			state.markets = action.payload;
		},
		setMarketId(state, action) {
			state.selectedMarketId = action.payload;
		},
		getBillingSuccess(state, action) {
			state.billing = action.payload;
		},
		// User List
		getUserListSuccess(state, action) {
			state.userList = action.payload;
		},
		getUserListError(state, action) {
			state.userListError = true;
			state.userListErrorMsg = action.payload;
		},
		setSelectedUserId(state, action) {
			state.selectedUserId = action.payload;
		},
		setUserPermission(state, action) {
			state.userPermission = action.payload;
		},
		inviteUserError(state, action) {
			state.inviteUserError = true;
			state.inviteUserErrorMsg = action.payload;
		},
		// Reset Error
		resetErrors(state) {
			state.personalInfoErr = false;
			state.personalInfoErrMsg = null;
			state.companyErr = false;
			state.companyErrMsg = null;
			state.userListError = false;
			state.userListErrorMsg = null;
			state.inviteUserError = false;
			state.inviteUserErrorMsg = null;
		},
		setCompanyErr(state, action) {
			state.companyErr = true;
			state.companyErrMsg = action.payload;
		},
		resetCompanyErr(state, action) {
			state.companyErr = false;
			state.companyErrMsg = null0;
		},
		setClientErr(state, action) {
			state.clientErr = true;
			state.clientErrMsg = action.payload;
		},
		resetClientErr(state, action) {
			state.clientErr = false;
			state.clientErrMsg = null;
		},
		setBrandErr(state, action) {
			state.brandErr = true;
			state.brandErrMsg = action.payload;
		},
		resetBrandErr(state, action) {
			state.brandErr = false;
			state.brandErrMsg = null;
		},
		setMarketErr(state, action) {
			state.marketErr = true;
			state.marketErrMsg = action.payload;
		},
		resetMarketErr(state, action) {
			state.marketErr = false;
			state.marketErrMsg = null;
		},
		resetSettingState(state) {
			// Personal Details
			state.personalInfo = null;
			state.personalInfoErr = false;
			state.personalInfoErrMsg = null;
			// Change Password
			state.changePasswordMsg = null;
			state.changePasswordError = false;
			// Company Details
			state.company = null;
			state.clients = null;
			state.selectedClientId = null;
			state.brands = null;
			state.selectedBrandId = null;
			state.markets = null;
			state.selectedMarketId = null;
			state.companyErr = false;
			state.companyErrMsg = null;
			state.billing = null;
			// User List
			state.userList = null;
			state.userListError = false;
			state.userListErrorMsg = null;
			state.selectedUserId = null;
			state.userPermission = null;
			state.inviteUserError = false;
			state.inviteUserErrorMsg = null;
			state.companyErr = false;
			state.companyErrMsg = null;
			state.clientErr = false;
			state.clientErrMsg = null;
			state.brandErr = false;
			state.brandErrMsg = null;
			state.marketErr = false;
			state.marketErrMsg = null;
		}
		/* eslint-enable require-jsdoc */
	},
	extraReducers: (builder) => {
		builder.addCase(ownPersonalInfo.fulfilled, (state, action) => {
			state.personalInfo = action.payload;
		});
		builder.addCase(getClientList.fulfilled, (state, action) => {
			state.clients = action.payload;
		});
		builder.addCase(getBrandList.fulfilled, (state, action) => {
			state.brands = action.payload;
		});
		builder.addCase(getMarketList.fulfilled, (state, action) => {
			state.markets = action.payload;
		});
		builder.addCase(getCompanyUsers.fulfilled, (state, action) => {
			state.userList = action.payload;
		});
		builder.addCase(getOtherUserPermission.fulfilled, (state, action) => {
			state.userPermission = action.payload;
		});
	}
});

export const {
	// Personal Details
	getOwnPersonalInfoSuccess,
	getOwnPersonalInfoErr,
	// Change Password
	passwordChangeSuccess,
	passwordChangeError,
	resetPwdChangeErr,
	resetPwdChangeSuccess,
	// Company Details
	getCompanySuccess,
	getCompanyError,
	getClientSuccess,
	getClientError,
	setClientId,
	getBrandSuccess,
	setBrandId,
	getMarketSuccess,
	setMarketId,
	getBillingSuccess,
	// User List
	getUserListSuccess,
	getUserListError,
	setSelectedUserId,
	setUserPermission,
	inviteUserError,
	// Reset Error
	resetErrors,
	setCompanyErr,
	resetCompanyErr,
	setClientErr,
	resetClientErr,
	setBrandErr,
	resetBrandErr,
	setMarketErr,
	resetMarketErr,
	resetSettingState
} = settingsSlice.actions;

export default settingsSlice.reducer;